import React, { useState, useEffect } from 'react';
import { ExtendReactlytics } from '@americanexpress/reactlytics';
import { OnVisible } from '@americanexpress/data-manager-utils';
import { Layout, Surface } from '@americanexpress/dls-react';
import { BackHeader } from '../../shared/components/BackHeader';
import { ViewApply } from './new/view-apply';
import { ViewSuccess } from './new/view-success';
import { TermBox } from './new/terms-box';
import LoadError from './LoadError';
import style from './enroll-page.css';

const heroImageClassName = style.heroImage;

export function EnrollPage(props) {
  const hasError = props?.readLoyaltyBenefitsError;
  const initialStepID = props?.readLoyaltyBenefits?.enrollment?.steps?.initial;
  const [currentEnrollmentStepID, setCurrentEnrollmentStep] = useState(initialStepID);
  const languageData = props?.languageData;

  if (hasError) {
    return <LoadError languageData={languageData} />;
  }

  // eslint-disable-next-line consistent-return -- needed
  const stepTransition = (next, fail) => {
    if (next) {
      const nextStep = props.readLoyaltyBenefits.enrollment.steps[currentEnrollmentStepID].next;
      return setCurrentEnrollmentStep(nextStep);
    }

    if (fail) {
      const failStep = props.readLoyaltyBenefits.enrollment.steps[currentEnrollmentStepID].fail;
      return setCurrentEnrollmentStep(failStep);
    }
  };

  const selectedProduct = props.selectedProduct;
  const cardname = props?.cardname;
  const benefitName = props?.benefitName;
  const benefitTitle = props?.readLoyaltyBenefits?.benefitTitle;
  const disclosures = props?.readLoyaltyBenefits?.disclosures || [];
  const enrollmentType = props?.readLoyaltyBenefits?.enrollment?.enrollType;
  const currentStepId = props?.readLoyaltyBenefits?.enrollment?.steps[currentEnrollmentStepID]?.id;
  const content = props?.readLoyaltyBenefits?.enrollment?.content[currentStepId];
  const validation = props?.readLoyaltyBenefits?.enrollment?.validation;
  const imageUrl = content?.images?.hero?.url;
  const faasApiUrl = props?.faasApiUrl;
  const sorBenefitId = props?.readLoyaltyBenefits?.sorBenefitId;
  const layoutType = props?.readLoyaltyBenefits?.layoutType;
  const locale = props?.locale;
  const subscriptionId = props?.readLoyaltyBenefits?.enrollmentApplication?.subscriptionId;
  const maxMiles = props?.readLoyaltyBenefits?.loanEligibility?.maxAmount?.value;
  const minMiles = props?.readLoyaltyBenefits?.loanEligibility?.minAmount?.value;
  const cardData = props?.cardData;
  const parseEntities = (txt) => new DOMParser().parseFromString(txt, 'text/html').body.textContent;
  const actionTag = `${cardname}>>enrollment`;

  // eslint-disable-next-line react-hooks/rules-of-hooks -- needed
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, []);

  return (
    <>
      <ExtendReactlytics
        analytics={{ event: { meta: { benefitname: benefitTitle?.replace(/ /g, '-').toLowerCase() } } }}
      >
        <BackHeader
          title={benefitTitle}
          url={props?.backHeaderData.url}
          accountKey={currentStepId === 'success' && props?.accountKey}
          actionTag={actionTag}
          reactlytics={{ element: parseEntities(actionTag)?.replace(/ /g, '-').toLowerCase() }}
        />
      </ExtendReactlytics>
      <Layout className="margin-2-tb margin-3-tb-lg-up col-xs-12 col-md-8 margin-auto-lr pad-0" innerContainerClassName="no-scroll border-0">
        <Surface
          role="region"
          aria-label="Benefit Enroll Section"
          variant="foreground"
        >
          <div className="col-md-12 col-sm-12 margin-auto pad-0">
            <div className="pad-0">
              <img
                src={imageUrl}
                alt=""
                aria-hidden={true}
                tabIndex={-1}
                className={heroImageClassName}
              />
            </div>
            {
              currentStepId === 'apply' && <ViewApply cardData={cardData} languageData={languageData} maxMiles={maxMiles} minMiles={minMiles} enrollmentType={enrollmentType} content={content} selectedProduct={selectedProduct} stepTransition={stepTransition} faasApiUrl={faasApiUrl} sorBenefitId={sorBenefitId} benefitName={benefitName} cardname={cardname} benefitTitle={benefitTitle} layoutType={layoutType} subscriptionId={subscriptionId} validation={validation} locale={locale} />
            }
            {
              currentStepId === 'success' && <ViewSuccess enrollmentType={enrollmentType} content={content} selectedProduct={selectedProduct} benefitName={benefitName} cardname={cardname} benefitTitle={benefitTitle} accountKey={props?.accountKey} />
            }
            {
              // Error doesn't have it's own analytics, im assuming, which is why <OnVisible /> is used here
              currentStepId === 'fail' && (
                <OnVisible
                  analyticsInfo={{ element: `error>>${cardname}>>${parseEntities(benefitTitle)}>>enrollment` }}
                  key="Error"
                >
                  <LoadError languageData={languageData} />
                </OnVisible>
              )
            }
            <TermBox disclosures={disclosures} cardname={cardname} benefitTitle={benefitTitle} localeDetails={locale} />
          </div>
        </Surface>
      </Layout>
    </>
  );
}

export default EnrollPage;
